import { useEffect } from 'react';
import GarrisonTriangle from '../../components/GarrisonTriangle';

function TrianglePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "The Garrison Triangle - Austrian Process";
  }, []);

  return <GarrisonTriangle />;
}

export default TrianglePage;
